import Joi from 'joi';

import { market } from '../../../../../../constants';

import i18n from '../../../../../../config/i18n/i18n';

import { phoneNumberValidator } from '../../personalDataForm/validation/schema';

export const schema = Joi.object({
  addressName: Joi.string()
    .min(3)
    .max(255)
    .error(new Error('Nombre de dirección requerido')),
  name: Joi.string()
    .min(3)
    .max(255)
    .error(new Error('Nombre de cliente requerido')),
  lastname: Joi.string()
    .min(3)
    .max(255)
    .error(new Error('Apellidos de cliente requerido')),
  phone: phoneNumberValidator.phone().validateNumber(),
  street: Joi.string()
    .min(3)
    .max(45)
    .error(new Error('Dirección requerida (máximo 45 caracteres)')),
  level1: Joi.number().error(new Error(i18n.t('localities.errors.level1'))),
  level2: Joi.number().error(new Error(i18n.t('localities.errors.level2'))),
  ...(market === 'pe' && {
    level3: Joi.number().error(new Error(i18n.t('localities.errors.level3'))),
  }),
  ...(market === 'cl' && {
    number: Joi.string().min(1).max(255).error(new Error('Número requerido')),
    houseType: Joi.string()
      .min(1)
      .max(255)
      .error(new Error('Tipo de vivienda requerido')),
  }),
});
